/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBatteryAutomotive = createReactComponent("outline", "battery-automotive", "IconBatteryAutomotive", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 5v-2", "key": "svg-1" }], ["path", { "d": "M18 3v2", "key": "svg-2" }], ["path", { "d": "M6.5 12h3", "key": "svg-3" }], ["path", { "d": "M14.5 12h3", "key": "svg-4" }], ["path", { "d": "M16 10.5v3", "key": "svg-5" }]]);

export { IconBatteryAutomotive as default };
//# sourceMappingURL=IconBatteryAutomotive.mjs.map
